import { render } from "./NavDropdownButton.vue?vue&type=template&id=8574abc0&ts=true"
import script from "./NavDropdownButton.vue?vue&type=script&lang=ts"
export * from "./NavDropdownButton.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__